import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import TrialExpiredScreen from "@/pages/TrialExpiredScreen";

/**
 * PO 2026-02 · Trial Paywall V1 — frontend guard.
 *
 * When the backend paywall middleware returns 402 for an operational
 * request, ``AuthContext`` sets ``entitlement === "expired"``. This
 * guard bounces every ``/app/*`` route (except the small allowlist)
 * to the ``TrialExpiredScreen`` — the contractor can still reach
 * ``/app/account`` to pay and restore access.
 *
 * Allowlisted routes ARE NOT wrapped by this component in ``App.js``
 * (they render outside the paywall guard) so the contractor never
 * gets bounced off the reactivation surface.
 */
const ALLOWLIST_PREFIXES = ["/app/account", "/app/support", "/app/legal"];

export default function PaywallRoute() {
  const { entitlement } = useAuth();
  const location = useLocation();
  if (entitlement === "expired" || entitlement === "checkout_required") {
    const p = location.pathname || "";
    const on_allowlist = ALLOWLIST_PREFIXES.some((prefix) => p.startsWith(prefix));
    if (!on_allowlist) return <TrialExpiredScreen mode={entitlement} />;
  }
  return <Outlet />;
}
